<template>
  <div class="background-imges">
    <router-view class="contentRouters" name="contentRouter"></router-view>
    <div v-if="showModal">
      <Modal @click="closeDialog" :title="modalValues.title" :type="modalValues.type" :message="modalValues.message"
        :show="modalValues.show" :size="modalValues.size" :theme="modalValues.theme" :accion="modalValues.accion" />
    </div>
  </div>
</template>
<script>
import Modal from '@/components/dialog/ModalDialog.vue';

export default {
  name: 'ContainerPage',
  components: {

    Modal,

  },
  computed: {

  },
  props: {
    theme: {
      type: String,
      default: 'yellow lighten-1',
      require: true
    },
    title: {
      type: String,
      default: 'Super Exito',
      require: true
    },
    menu: {
      require: false
    },
    usuario: {
      require: false
    },

  },
  data() {
    return {
      ambiente: '',
      drawer: true,
      openTitle: false,
      tipoRol: null,
      showModal: false,
      showSnackBars: false,
      modalValues: {
        title: null,
        type: null,
        message: null,
        show: null,
        size: null,
        theme: null,
        accion: null
      }
    }
  },
  methods: {
    /*   ...mapActions(["getSession", "logoutSession", "resetModuleParms"]), */

    /* getColorTheme(seccion) {
      let colorModificado;
      let primaryColor;
      switch (seccion) {
        case 1:
          colorModificado = this.theme;
          break;
        case 2:
          colorModificado = this.theme.slice(0, -2) + '-' + String(parseInt(this.theme.slice(-1) + 1));
          break;
        case 3:
          primaryColor = this.theme.split(' ');
          colorModificado = primaryColor[0] + '--text ' + 'text--' + primaryColor[1];
          break;
        default:
          break;
      }
      return {
        [colorModificado]: true
      }
    }, */
    /* logout() {
      this.$router.push({ path: '/login' })
      this.logoutSession();
    }, */
    closeDialog() {
      this.showModal = false

    }, openDialog(title, type, message, show, size, theme, accion) {
      this.showModal = true;
      this.modalValues = {
        title: title,
        type: type,
        message: message,
        show: show,
        size: size,
        theme: theme,
        accion: accion,
      }
    },
    /*  accionDots(valor) {
       switch (valor) {
         case 1:
           this.openDialog(this.title, 2, '¿ Esta seguro(a) de salir del modulo ' + this.title + ' ?', true, '500', this.theme, this.goModulePage);
           break;
         case 2:
           this.openDialog(this.title, 2, '¿ Esta seguro(a) de salir del sistema ?', true, '500', this.theme, this.logout);
           break;
       }
     }, */
    /*  goModulePage() {
       this.$router.push({ path: '/modulos' })
       this.resetModuleParms()
     }, */
    openSnackBars() {
      this.showSnackBars = true;
    }
  },
  /*  beforeMount() {
     this.getSession();
     this.ambiente = ipServer.split(':')[1] == '//192.168.8.202' ? 'Producción' : 'Desarrollo'
   } */
}
</script>
<style scoped></style>